"use strict";
/**
 * Copyright 2023 actions-toolkit authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitHub = void 0;
const core = __importStar(require("@actions/core"));
const github = __importStar(require("@actions/github"));
const jwt_decode_1 = require("jwt-decode");
class GitHub {
    octokit;
    constructor(opts) {
        this.octokit = github.getOctokit(`${opts?.token}`);
    }
    repoData() {
        return this.octokit.rest.repos.get({ ...github.context.repo }).then(response => response.data);
    }
    static get context() {
        return github.context;
    }
    static get serverURL() {
        return process.env.GITHUB_SERVER_URL || 'https://github.com';
    }
    static get apiURL() {
        return process.env.GITHUB_API_URL || 'https://api.github.com';
    }
    static get actionsRuntimeToken() {
        const token = process.env['ACTIONS_RUNTIME_TOKEN'] || '';
        return token ? (0, jwt_decode_1.jwtDecode)(token) : undefined;
    }
    static async printActionsRuntimeTokenACs() {
        let jwt;
        try {
            jwt = GitHub.actionsRuntimeToken;
        }
        catch (e) {
            throw new Error(`Cannot parse GitHub Actions Runtime Token: ${e.message}`);
        }
        if (!jwt) {
            throw new Error(`ACTIONS_RUNTIME_TOKEN not set`);
        }
        try {
            JSON.parse(`${jwt.ac}`).forEach(ac => {
                let permission;
                switch (ac.Permission) {
                    case 1:
                        permission = 'read';
                        break;
                    case 2:
                        permission = 'write';
                        break;
                    case 3:
                        permission = 'read/write';
                        break;
                    default:
                        permission = `unimplemented (${ac.Permission})`;
                }
                core.info(`${ac.Scope}: ${permission}`);
            });
        }
        catch (e) {
            throw new Error(`Cannot parse GitHub Actions Runtime Token ACs: ${e.message}`);
        }
    }
}
exports.GitHub = GitHub;
//# sourceMappingURL=github.js.map